export const popularCityTextClick = {
    event: "popular_city_text_click",
    eventCategory: "homepage_dweb",
    eventAction: "popular_city_clicked"
};

export const evaluateCarPriceClicked = {
    event: "evaluate_car_price_cta",
    eventCategory: "homepage",
    eventAction: "Evaluate_car_price_clicked",
    eventLabel: "used-car-valuation"
};

export const evaluateCarPriceBottomClicked = {
    ...evaluateCarPriceClicked,
    eventAction: "Get_car_price_bottom"
};
